"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var Link = function Link(_ref) {
  var className = _ref.className,
      href = _ref.href,
      children = _ref.children,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$dotted = _ref.dotted,
      dotted = _ref$dotted === void 0 ? false : _ref$dotted,
      maxWidth = _ref.maxWidth,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "href", "children", "onClick", "disabled", "dotted", "maxWidth"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = (0, _style["default"])({
    theme: theme,
    props: {
      maxWidth: maxWidth
    }
  });
  return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({}, rest, {
    href: href,
    className: (0, _classnames["default"])(classes.Link, className, disabled && classes.Disabled, dotted && classes.Dotted, maxWidth ? 'cap-width' : ''),
    onClick: !disabled ? onClick : undefined
  }), children);
};

exports["default"] = Link;
//# sourceMappingURL=index.js.map